export default __webpack_public_path__ + "static/media/Inter-Row Rotary Tiller.89d381ba.png";